import { Component, OnInit } from '@angular/core';
import { NavigationService } from './navigation.service';
import { navStepperConfig } from './stepper-navigation.config';

@Component({
  selector: 'app-stepper-navigation',
  templateUrl: './stepper-navigation.component.html',
  styleUrls: ['./stepper-navigation.component.scss'],
  providers: [
    NavigationService,
  ]
})
export class StepperNavigationComponent implements OnInit {

  stepperConfig = navStepperConfig
  constructor(public navigationService: NavigationService) { }

  ngOnInit() {
  }

  onReadyEvent(event) {

  }

}
